<template>
    <div
        v-tinymce="options"
        :key="renderKey"
        @mce-change="(et) => offerSectionSet({ executionTypes: et })"
        @mce-dirty="() => $emit('dirty')"
    >
        <div
            v-if="offerSections.executionTypes"
            v-html="offerSections.executionTypes"
        ></div>
        <div
            v-else
            class="executionTypes"
        >
            <h3>{{ $t('executionTypes.heading') }}</h3>
            <p class="mb-4">{{ $t('executionTypes.intro') }}</p>
            <b-row>
                <b-col
                    md="4"
                    class="mb-4"
                    :key="index"
                    v-for="(et, index) in executionTypes"
                >
                    <div :class="['card', 'execution-type', et.className, { 'selected-execution-type': et.selected }]">
                        <div
                            class="execution-type-icon"
                            v-html="et.svgIcon"
                        ></div>
                        <div class="card-body pt-2">
                            <strong
                                class="selected-execution-type-label"
                                v-if="et.selected"
                            >{{ $t('executionTypes.selected') }}</strong>
                            <h5>{{ et.label }}</h5>
                            <p
                                v-html="et.description"
                                class="mt-4"
                            ></p>
                        </div>
                    </div>
                </b-col>
            </b-row>
        </div>
    </div>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex';
export default {
  name: "ExecutionTypes",
  props: {
    options: Object,
  },
  computed: {
    ...mapGetters(["offerSections", "offerType", "offer"]),
    isOpenSeminar() {
      return this.offer && parseInt(this.offer.offerType_id) === 4;
    },
    executionTypes: function () {
      return Object.keys(this.executionTypesData)
        .filter((k) => !(k === "hybrid" && this.isOpenSeminar))
        .map((k) => {
          const executionType = { ...this.executionTypesData[k] };
          executionType.label = this.$t(`executionTypes.${k}Label`);
          executionType.description = this.$t(`executionTypes.${k}`);

          // Remove the advantage sentence for Online-Schulung in open seminars
          if (k === "remote" && this.isOpenSeminar) {
            executionType.description = this.$t('executionTypes.remoteOpen');
          }

          if (k === "presence" && this.isOpenSeminar) {
            executionType.description = this.$t('executionTypes.presenceOpen');
          }

          if (
            ((k === "remote" && this.offer && this.offer.isRemote) ||
              (k === "presence" && this.offer && !this.offer.isRemote)) &&
            this.offerType.id !== 3
          ) {
            executionType.selected = true;
          }

          return executionType;
        })
        .sort((a, b) => {
          const x = a.selected ? 1 : 0;
          const y = b.selected ? 1 : 0;
          return y - x;
        });
    },
  },
  data: function () {
    return {
      executionTypesData: {
        remote: {
          svgIcon:
            '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 62 47" fill="currentColor" height="100%"> <path d="M9 6c0-1.1.9-2 2-2h40c1.1 0 2 .9 2 2v29h4V6c0-3.31-2.69-6-6-6H11C7.69 0 5 2.69 5 6v29h4V6zM61 37H39v3H23v-3H1c-.55 0-1 .45-1 1 0 4.96 4.04 9 9 9h44c4.96 0 9-4.04 9-9 0-.55-.45-1-1-1z"/> <g> <path d="M40.99 18.41h1.5v6.75h-1.5zM32.19 23.45c-.6.28-1.3.28-1.9 0l-7.3-3.41v5.87c0 2.52 3.62 4.5 8.25 4.5s8.25-1.98 8.25-4.5v-5.87l-7.3 3.41z"/> <path d="M42.81 15.48l-11.25-5.25a.769.769 0 00-.63 0l-11.25 5.25a.753.753 0 000 1.36l11.25 5.25c.2.09.43.09.63 0l11.25-5.25a.753.753 0 000-1.36z"/> </g> </svg>',
        },
        presence: {
          svgIcon:
            '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 62 47" fill="currentColor" height="100%"> <circle cx="8.77" cy="5.65" r="5"/> <path d="M29.77 14.65a2 2 0 00-2-2h-20a5 5 0 00-5 5v26.5a2.5 2.5 0 005 0v-12.5h2v12.5a2.5 2.5 0 005 0v-27.5h13a2 2 0 002-2z"/> <path d="M27.77 18.65h-11v15h19.46a36.88 36.88 0 015.65-1.07 9.36 9.36 0 01-5-8.26V23a9.34 9.34 0 019.34-9.33h.54v-8a1 1 0 00-1-1h-18v-3a1 1 0 10-2 0v3H15.69a6.83 6.83 0 01-2 6h14.08a4 4 0 110 8z"/> <path d="M46.23 31.66a7.34 7.34 0 007.33-7.34V23a7.34 7.34 0 00-14.67 0v1.33a7.34 7.34 0 007.34 7.33zM56.41 35.78a36.26 36.26 0 00-20.37 0 5.3 5.3 0 00-3.81 5.11v4.77a.66.66 0 00.66.66h26.67a.67.67 0 00.67-.66v-4.77a5.3 5.3 0 00-3.82-5.11z"/> </svg>',
        },
        hybrid: {
          svgIcon:
            '<svg viewBox="155.007 128.756 137.072 47.754" fill="currentColor" height="100%"> <circle cx="161.007" cy="133.756" r="5"/> <path d="M 182.007 142.756 C 182.007 141.651 181.112 140.756 180.007 140.756 L 160.007 140.756 C 157.246 140.756 155.007 142.994 155.007 145.756 L 155.007 172.256 C 155.007 174.18 157.091 175.383 158.757 174.421 C 159.531 173.974 160.007 173.149 160.007 172.256 L 160.007 159.756 L 162.007 159.756 L 162.007 172.256 C 162.007 174.18 164.091 175.383 165.757 174.421 C 166.531 173.974 167.007 173.149 167.007 172.256 L 167.007 144.756 L 180.007 144.756 C 181.112 144.756 182.007 143.86 182.007 142.756 Z"/> <path d="M 180.007 146.756 L 169.007 146.756 L 169.007 161.756 L 188.467 161.756 C 190.32 161.253 192.209 160.895 194.117 160.686 C 191.049 159.071 189.126 155.893 189.117 152.426 L 189.117 151.106 C 189.123 145.951 193.303 141.776 198.457 141.776 L 198.997 141.776 L 198.997 133.776 C 198.997 133.224 198.55 132.776 197.997 132.776 L 179.997 132.776 L 179.997 129.776 C 179.997 129.006 179.164 128.525 178.497 128.91 C 178.188 129.089 177.997 129.419 177.997 129.776 L 177.997 132.776 L 167.927 132.776 C 168.283 134.983 167.536 137.224 165.927 138.776 L 180.007 138.776 C 183.086 138.776 185.011 142.109 183.471 144.776 C 182.757 146.014 181.436 146.776 180.007 146.776 L 180.007 146.756 Z"/> <path d="M 198.467 159.766 C 202.517 159.76 205.797 156.476 205.797 152.426 L 205.797 151.106 C 205.589 145.459 199.346 142.156 194.56 145.16 C 192.502 146.452 191.217 148.678 191.127 151.106 L 191.127 152.436 C 191.133 156.486 194.417 159.766 198.467 159.766 Z M 208.647 163.886 C 201.997 161.94 194.928 161.94 188.277 163.886 C 186.01 164.55 184.457 166.634 184.467 168.996 L 184.467 173.766 C 184.467 174.13 184.763 174.426 185.127 174.426 L 211.797 174.426 C 212.163 174.426 212.462 174.132 212.467 173.766 L 212.467 168.996 C 212.477 166.631 210.918 164.546 208.647 163.886 Z"/> <path d="M 239.079 135.51 C 239.079 134.41 239.979 133.51 241.079 133.51 L 281.079 133.51 C 282.179 133.51 283.079 134.41 283.079 135.51 L 283.079 164.51 L 287.079 164.51 L 287.079 135.51 C 287.079 132.2 284.389 129.51 281.079 129.51 L 241.079 129.51 C 237.769 129.51 235.079 132.2 235.079 135.51 L 235.079 164.51 L 239.079 164.51 L 239.079 135.51 Z M 291.079 166.51 L 269.079 166.51 L 269.079 169.51 L 253.079 169.51 L 253.079 166.51 L 231.079 166.51 C 230.529 166.51 230.079 166.96 230.079 167.51 C 230.079 172.47 234.119 176.51 239.079 176.51 L 283.079 176.51 C 288.039 176.51 292.079 172.47 292.079 167.51 C 292.079 166.96 291.629 166.51 291.079 166.51 Z"/> <g transform="matrix(1, 0, 0, 1, 230.078601, 129.510012)"> <path d="M40.99 18.41h1.5v6.75h-1.5zM32.19 23.45c-.6.28-1.3.28-1.9 0l-7.3-3.41v5.87c0 2.52 3.62 4.5 8.25 4.5s8.25-1.98 8.25-4.5v-5.87l-7.3 3.41z"/> <path d="M42.81 15.48l-11.25-5.25a.769.769 0 00-.63 0l-11.25 5.25a.753.753 0 000 1.36l11.25 5.25c.2.09.43.09.63 0l11.25-5.25a.753.753 0 000-1.36z"/> </g> <path d="M 220.189 146.843 H 222.447 V 151.358 H 226.962 V 153.616 H 222.447 V 158.131 H 220.189 V 153.616 H 215.674 V 151.358 H 220.189 Z" style="" bx:shape="cross 215.674 146.843 11.288 11.288 2.258 2.258 0.5 1@786cdacd"/> </svg>',
        },
      },
      renderKey: 0,
    };
  },
  methods: {
    ...mapMutations(["offerSectionSet"]),
  },
};
</script>
<style scoped>
.selected-execution-type {
    background: #042b60;
    color: #fff;
}

.selected-execution-type-label {
    background-color: #fdc41f;
    display: inline-block;
    position: absolute;
    color: #033878;
    top: -2rem;
    padding: 0.1rem 0.5rem;
    border-radius: 0.15rem;
}

.execution-type {
    position: relative;
}

.execution-type .card-body {
    z-index: 1;
    position: relative;
}

.execution-type-icon {
    width: 100%;
    height: 4.4rem;
    position: absolute;
    z-index: 0;
    top: 0.5em;
    right: 0;
    text-align: right;
    padding: 1rem;
    padding-bottom: 20px;
}

.selected-execution-type .execution-type-icon {
    color: #fff;
}
</style>
